import {
  BottomNavigation,
  BottomNavigationAction,
  Box, Drawer,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import React, { useState } from 'react';
import MenuList from './MenuList';

export default function PrimaryMenuXS() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown'
          && ((event as React.KeyboardEvent).key === 'Tab'
            || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  return (
    <Box
      sx={{
        display: { xs: 'block', md: 'none' },
      }}
    >
      <BottomNavigation
        showLabels
      >
        <BottomNavigationAction
          sx={{
            '& .MuiBottomNavigationAction-label': {
              fontWeight: 'bold',
            },
            backgroundColor: '#B4B4B4',
          }}
          label="Menu"
          icon={<MenuIcon color="info" />}
          onClick={toggleDrawer(true)}
        />
      </BottomNavigation>
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <MenuList />
        </Box>
      </Drawer>
    </Box>
  );
}
